import { css } from "styled-components"

export const ourPreviousWork = css`

  section { 
    padding-top: 100px;
    padding-bottom: 300px;
  }

  p.text {
    font-size: 24px;
    line-height: 34px;
    margin-bottom: 60px;
  }

  .testimonials {
    
    box-sizing: border-box;
    margin: 0 auto;
    margin-top: 100px;
    max-width: 950px;
    position: relative;
    min-height: 440px;

    &--inner-container {
      max-width: 925px;
      position: relative;
      z-index: 2;
    }

    &__testimonial {

      width: 100%;
      height: 300px;
      background-color: white;
      border: 3px solid #ECECED;
      border-radius: 0px 0px 50px 10px;
      
      padding-top: 60px;
      padding-left: 165px;
      padding-right: 36px;
      box-sizing: border-box;

      @media (max-width: 768px) {
        overflow-y: scroll;

        height: 300px;
        padding-left: 65px;

        &:after {
          content: " ";
          position: absolute;
          bottom: 3px;
          width: 95%;
          height: 36px;
          left: 3px;
          border-radius: 0 0 50px 40px;
          background: linear-gradient(0deg, rgba(255,255,255,1) 35%, rgba(64,64,64,0) 100%);
        }

        padding-bottom: 70px;

        ::-webkit-scrollbar {
          -webkit-appearance: none;
          width: 7px;
        }
        ::-webkit-scrollbar-thumb {
          border-radius: 4px;
          background-color: rgba(0,0,0,.5);
          box-shadow: 0 0 1px rgba(255,255,255,.5);
          -webkit-box-shadow: 0 0 1px rgba(255,255,255,.5);
        }
      }

      &__source-logo {
        position: absolute;
        top: 0;
        left: 0;
        width: 125px;
        height: 125px;
        background-image: url('/upwork-logo.png');
        background-size: cover;
        background-repeat: no-repeat;

        @media (max-width: 768px) {
          width: 55px;
          height: 55px;
        }
      }

      &__content {

        &__title {
          margin-bottom: 15px;
        }

        &__text {
          line-height: 26px;
        }

        &__divider {
          height: 1px;
          width: 100%;
          background-color: #e4e4e4;
          border: none; /* @TODO - reset <hr> without borders */
          margin-top: 30px;
          margin-bottom: 20px;
        }

        &__rating {

          /* @temp */
          color: #48E4B7;
          font-size: 24px;
          color: lightgreen;
        }

      }

    }

    &--bottom-nav-container {
      position: absolute;
      z-index: 1;
      top: 75px;
      left: -20px;
      background-color: #FCEDBD;
      border-radius: 0px 0px 50px 10px;
      width: 513px;
      height: 300px;
    }
    
    &__nav {

      position: absolute;
      bottom: 20px;
      left: 25px;

    }

  }

  .testimonials-notice {

    max-width: 950px;
    margin: 0 auto;

    &__texts {

      &__notice-prefix-text {
        font-weight: bold;
        text-decoration: underline;
      }

      &__text {
        display: inline;
        font-style: italic;
        line-height: 1.6;

        a {
          font-weight: bold;
        }
      }

    }

  }


`